module.exports = __webpack_public_path__ + "img/img19.a7ace962.png";